import ApplicationAdapter from 'eflex/adapters/application';

export default class LightGuideAdapter extends ApplicationAdapter {
  pathForType() {
    return 'hardwares';
  }
}
